export function delay(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}